'use client';

import { useMemo } from 'react';

import { useTranslation } from '@/hooks/useTranslation';

import { modelApi, type RobotModel } from '../../_lib/api';
import { EnabledBadge, EntityAdminPage } from '../_lib/EntityAdminPage';

export default function ModelsAdminPage() {
  const { t } = useTranslation();
  const rm = t.robotManager;

  const columns = useMemo(
    () => [
      { key: 'code' as const, label: 'Code' },
      { key: 'name' as const, label: rm.admin.name },
      { key: 'brand' as const, label: rm.entities.models.brand },
      {
        key: '_count' as const,
        label: rm.entities.models.skuCount,
        render: (r: RobotModel) => `${r._count?.skus ?? 0} / ${r._count?.robotUnits ?? 0}`,
      },
      {
        key: 'enabled' as const,
        label: rm.admin.status,
        render: (r: RobotModel) => <EnabledBadge enabled={r.enabled} />,
      },
    ],
    [rm],
  );

  const fields = useMemo(
    () => [
      { name: 'code' as const, label: 'Code', placeholder: '留空自动生成，例：AEGIS', hint: rm.admin.codeAutoGeneratedHint },
      { name: 'name' as const, label: rm.admin.name, required: true, placeholder: '如 Aegis 系列' },
      { name: 'brand' as const, label: rm.entities.models.brand, placeholder: '如 FF' },
      { name: 'description' as const, label: rm.entities.description, type: 'textarea' as const },
      { name: 'imageUrl' as const, label: rm.entities.imageUrl },
      { name: 'enabled' as const, label: rm.admin.enabled, type: 'checkbox' as const },
    ],
    [rm],
  );

  return (
    <EntityAdminPage<RobotModel> excelResource="models"
      title={rm.entities.models.title}
      description={rm.entities.models.description}
      api={modelApi}
      columns={columns}
      fields={fields}
      searchPlaceholder={rm.entities.models.searchPlaceholder}
    />
  );
}
